var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fp-spinner",style:({ height: _vm.getHeight })},[_c('img',{attrs:{"src":require("@/assets/spinner.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }